import { render, staticRenderFns } from "./CurrencyAttribute.vue?vue&type=template&id=72dbddaf&"
import script from "./CurrencyAttribute.vue?vue&type=script&lang=js&"
export * from "./CurrencyAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports